<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>回收站</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.is_self">
                <el-select filterable v-model="is_self" placeholder="请选择回收站" clearable>
                    <el-option v-for="item in levelOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.rel_type">
                <el-select filterable v-model="rel_type" placeholder="请选择删除对象" clearable>
                    <el-option v-for="item in reltypeOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.value1">
                <el-date-picker
                    v-model="value1"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    clearable
                >
                </el-date-picker>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button class="btn_success" size="small" plain @click="okPass(3)" v-if="postList.clearBtn">清空回收站</el-button>
                <!-- <el-button class="btn_error" size="small" plain @click="okPass(4)">还原回收站</el-button> -->
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(0, 1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(1)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >
                    <!-- 设置子组件 调整列显示隐藏 顺序 -->
                    <draggableList :draggable="draggable" @isErrShow="isErrshow" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                @sort-change="changeSort"
                :max-height="this.$tableHeight"
                @header-dragend="changeColWidth"
                class="recycle"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
                @selection-change="selectionChange"
            >
                <el-table-column type="selection" width="45" fixed="left"></el-table-column>
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%" :style="(wdith = item.width)">
                            <div>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page.sync="page"
                    :page-size="row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize } from '../../../../js/common';
import draggableList from '../../../common/Drawer.vue';
export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList
    },
    name: 'recycleComponent',
    data() {
        return {
            draggable: {
                data_name: 'recycle'
            },
            parentOptions: [],
            down_loading: false,
            updateLoading: false,
            tableData: [],
            colData: [],
            total: 0,
            page: 1,
            row: 25,
            sort: '', //排序参数
            data_name: '', //排序参数
            loading: true,
            is_self: '1',
            rel_type: '',
            value1: '',
            levelOptions: [
                {
                    value: '1',
                    label: '我的回收站'
                },
                {
                    value: '2',
                    label: '全局回收站'
                }
            ], //省市区等级
            reltypeOptions: [], //删除对象列表
            selected: []
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        //详情内调用不用本地存储的params
        if (!this.postList.params) {
            //列表页面调用 优先取本地存储
            var paramsList = JSON.parse(localStorage.getItem('paramsList'));
            if (paramsList['recycle_params']) {
                this.page = paramsList['recycle_params'].page;
                this.row = paramsList['recycle_params'].row;
                this.is_self = paramsList['recycle_params'].is_self;
                // this.data_name = paramsList['recycle_params'].data_name;
                // this.sort = paramsList['recycle_params'].sort;
                this.start_date = paramsList['recycle_params'].start_date;
                this.end_date = paramsList['recycle_params'].end_date;
                this.value1 = paramsList['recycle_params'].value1;
                this.rel_type = paramsList['recycle_params'].rel_type;
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.getRecycles();
            this.selectedColData(); //筛选列
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.row = 10;
                this.getList(0); //获取列表
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        //子组件更新完毕
        isErrshow(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('recycle', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).recycle;
        },
        // 从后台获取数据,重新排序
        changeSort(val) {
            this.data_name = val.prop;
            if (val.order == 'ascending') {
                this.sort = 'asc';
            } else if (val.order == 'descending') {
                this.sort = 'desc';
            }
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['recycle_params']) {
                    newParamsList['recycle_params'].data_name = val.prop;
                    newParamsList['recycle_params'].sort = this.sort;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            if (this.sort !== '') {
                this.getList(0); //获取列表
            }
        },
        //type == 3 清空回收站 type ==4 还原回收站
        okPass(type) {
            if (this.selected.length == 0) {
                this.$message.warning('当前未选择数据！');
                return false;
            }
            let message;
            let messageType;
            if (type == 3) {
                //此处为通过
                message = `确认清空回收站吗?`;
                messageType = 'warning';
                this.$msgbox
                    .confirm(message, {
                        type: messageType,
                        closeOnClickModal: false
                    })
                    .then(() => {
                        let approvalList = [];
                        this.selected.forEach((value) => {
                            approvalList.push(value.id);
                        });
                        let postData = {
                            ids: approvalList
                        };
                        this.$api
                            .recycleBatchDelete(postData)
                            .then((res) => {
                                if (res.code == 0) {
                                    this.$message({
                                        message: '操作成功!',
                                        type: 'success'
                                    });
                                    this.getList(0); //获取列表
                                }
                            })
                            .catch((error) => {
                                
                            });
                    })
                    .catch(() => {
                    });
            } else if (type == 4) {
                //此处为通过
                message = `确认还原回收站吗?`;
                messageType = 'warning';
                this.$msgbox
                    .confirm(message, {
                        type: messageType,
                        closeOnClickModal: false
                    })
                    .then(() => {
                        let approvalList = [];
                        this.selected.forEach((value) => {
                            approvalList.push(value.id);
                        });
                        let postData = {
                            ids: approvalList
                        };
                        this.$api
                            .recycleRestore(postData)
                            .then((res) => {
                                if (res.code == 0) {
                                    this.$message({
                                        message: '操作成功!',
                                        type: 'success'
                                    });
                                    this.getList(0); //获取列表
                                }
                            })
                            .catch((error) => {
                                
                            });
                    })
                    .catch(() => {
                    });
            }
        },
        // 多选选择框选择
        selectionChange(val) {
            this.selected = val;
        },
        //删除对象下拉列表
        getRecycles() {
            var params = {};
            this.$api
                .dropdownRecycles(params)
                .then((res) => {
                    if (res.code == 0) {
                        let data = res.data;
                        Object.keys(data).forEach((key) => {
                            this.reltypeOptions.push({
                                value: key,
                                label: data[key]
                            });
                        });
                    }
                })
                .catch((error) => {
                    
                });
        },
        //获取列表数据
        getList(type_data, type) {
            if (type == 1) {
                this.page = 1;
            }
            var params = {
                page: this.page,
                row: this.row,
                is_self: this.is_self,
                start_date: this.value1[0] ? this.value1[0] : '',
                end_date: this.value1[1] ? this.value1[1] : '',
                value1: this.value1,
                rel_type: this.rel_type ? this.rel_type : '',
                is_export: type_data
            };
            //当点击 或者触发回车事件保存参数
            if (type == 1) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                newParamsList['recycle_params'] = params;
                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            }
            if (type_data == 0) {
                this.loading = true;
                this.$api
                    .recycleLists(params)
                    .then((res) => {
                        this.loading = false;
                        if (res.code == 0) {
                            this.tableData = res.data.data;
                            this.total = res.data.total;
                            //判断当前搜素页面参数是否大于最后一页 大于的话取最后一页的参数存起来并用最后一页的参数请求
                            if (res.data.current_page > res.data.last_page) {
                                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                                newParamsList['recycle_params'].page = res.data.last_page;
                                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                                this.page = res.data.last_page;
                            }
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                        
                    });
            } else {
                this.down_loading = true;
                params.page = 1;
                this.$api
                    .recycleListsDownFile(params)
                    .then((res) => {
                        this.$message({
                            message: '下载成功!',
                            type: 'success'
                        });
                        this.down_loading = false;
                    })
                    .catch((error) => {
            
                        this.down_loading = false;
                        
                    });
            }
        },
        // 点击分页当前页数
        currentChange(val) {
            this.page = val;
            //当分页发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['recycle_params']) {
                    newParamsList['recycle_params'].page = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        is_self: this.is_self,
                        start_date: this.value1[0] ? this.value1[0] : '',
                        end_date: this.value1[1] ? this.value1[1] : '',
                        value1: this.value1,
                        rel_type: this.rel_type ? this.rel_type : ''
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['recycle_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },
        // 切换每页条数
        sizeChange(val) {
            this.row = val;
            //当页数发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['recycle_params']) {
                    newParamsList['recycle_params'].row = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        is_self: this.is_self,
                        start_date: this.value1[0] ? this.value1[0] : '',
                        end_date: this.value1[1] ? this.value1[1] : '',
                        value1: this.value1,
                        rel_type: this.rel_type ? this.rel_type : ''
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['recycle_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },
        //重置页面数据
        reset() {
            this.is_self = '';
            this.rel_type = '';
            this.value1 = '';
            this.sort = '';
            this.data_name = '';
            this.parent_rid = '';
            this.page = 1;
            this.row = 25;
            var params = {
                page: 1,
                row: 25,
                sort: ['', ''],
                is_self: '',
                rel_type: '',
                value1: ''
            };
            var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
            newParamsList['recycle_params'] = params;
            localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            this.getList(0);
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>